module.exports = __webpack_public_path__ + "static/media/bg-additional-test.1d5288fe.png";